import React from "react";
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber'

const useStyles = makeStyles((theme) => ({
  dialog: {
    border: 'none !important',
    borderRadius: '8px',
    padding: theme.spacing(2),
    borderTop: '12px solid #00a350 !important',
    padding: '15px 25px',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(0, 1.5, 1.5),
  },
  iconWrapper: {
    flex: 2, 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  confirmIcon: {
    color: '#00a350', 
    fontSize: '50px',
  },
  title: {
    fontWeight: "bold",
    fontSize: '20px',
    color: 'black',
    padding: theme.spacing(0, 3)
  },
  message: {
    fontSize: '15px',
    color: theme.palette.text.primary,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-end',
    padding: theme.spacing(1.25, 0, 0),
    borderTop: '1px solid #d3cccc'
  },
  button: {
    padding: theme.spacing(1, 2),
    textTransform: 'capitalize',
  },
  buttonConfirm: {
    padding: theme.spacing(1, 2),
    backgroundColor: '#00a350', 
    border: '1px solid #00a350', 
    color: '#fff',
    fontSize: '14px',
    marginLeft: "15px",
    width: '120px',
    '&:hover': {
      backgroundColor: '#14653c', 
      border: '1px solid #14653c', 
    },
  },
  buttonCancel: {
    padding: theme.spacing(1, 5),
    backgroundColor: '#fff',
    color: '#000',
    fontSize: '14px',
    border: '1px solid #757575', 
    width: '120px',
    '&:hover': {
      border: '1px solid #00a350', 
    },
  },
  
}))

const ModalConfirm = ({ title, content, isOpen, onClose, onConfirm }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Dialog open={isOpen} onClose={onClose} aria-labelledby="confirm-dialog-title" classes={{ paper: classes.dialog }}>
      <div className={classes.container}>
        <div className={classes.iconWrapper}>
        <ConfirmationNumberIcon className={classes.confirmIcon} />
        </div>
        <div>
          <DialogTitle id="confirm-dialog-title" className={classes.title}>{title}</DialogTitle>
          <DialogContent>
        <Typography className={classes.message}>{content}</Typography>
      </DialogContent>
        </div>
      </div>
          
      
      <DialogActions className={classes.actions}>
        <Button onClick={onClose} color="primary" className={classes.buttonCancel}>
          {t('common.btn.cancel')}
        </Button>
        <Button onClick={onConfirm} color="secondary" className={classes.buttonConfirm}>
         {t('common.btn.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ModalConfirm.propTypes = {
  open: PropTypes.bool.isRequired, // Modal có hiển thị không
  onClose: PropTypes.func.isRequired, // Hàm đóng modal
  onConfirm: PropTypes.func.isRequired, // Hàm xác nhận hành động
  title: PropTypes.string, // Tiêu đề của modal
  message: PropTypes.string, // Nội dung của modal
  confirmText: PropTypes.string, // Text trên nút xác nhận
  cancelText: PropTypes.string, // Text trên nút hủy
  confirmColor: PropTypes.oneOf(['default', 'primary', 'secondary']), // Màu nút xác nhận
  cancelColor: PropTypes.oneOf(['default', 'primary', 'secondary']), // Màu nút hủy
}

export default ModalConfirm;
